<i _ngcontent-c8="" class="fa fa-square" [ngClass]="{
    'online': gateway.seenOnline,
    'offline':!gateway.seenOnline && gateway.statusTitle==='Deployed', 
    'standby':!gateway.seenOnline && gateway.statusTitle!=='Deployed'}" [title]="gateway.seenOnline ? 'online': !gateway.seenOnline && gateway.statusTitle==='Deployed'?'offline':'standby'"></i> &nbsp;